import { message } from 'aui';
import type { Any } from '../constant/any';
import type { LocaleType } from '../i18n/i18n';
import { RequestErrorMessageType, request } from './request';

const errorCodeMessageMap: Record<string, keyof LocaleType> = {
  '403010': 'message.noPrivilege',
  '403011': 'message.noPrivilege',
  '403012': 'message.noPrivilege',
  '403013': 'message.noPrivilege',
  '403021': 'message.noPrivilege',
  '403022': 'message.noPrivilege',
  '401006': 'user.login.password.tooManyErrors',
  '401007': 'user.request.message.rateLimit',
  '401008': 'user.login.message.invalidCaptcha',
  '401000': 'user.login.password.error',
  '400122': 'user.login.message.invalidCaptcha.tip',
  '404010': 'onlineShare.expired',
  '404000': 'onlineShare.notShared',
};

export async function clientRequest<T>(
  args1: Parameters<typeof request>[0],
  args2: Omit<Parameters<typeof request>[1], 'onErrorMessage'>,
  clientI18n: (key: keyof LocaleType, params?: Record<string, string>) => string,
  isNoErrorMessage?: boolean,
) {
  return await request<T>(
    args1,
    {
      ...(args2 ?? {}),
      onErrorMessage: (err) => {
        if (isNoErrorMessage) {
          return;
        }

        if (err.type === RequestErrorMessageType.FailedFetch) {
          message.error(clientI18n('message.networkFailure'));
        } else if (err.type === RequestErrorMessageType.ServerFailure) {
          message.error(clientI18n('message.serverFailure'));
        } else {
          if (Object.keys(errorCodeMessageMap).includes(err.errorCode)) {
            const errorCode: keyof typeof errorCodeMessageMap = err.errorCode as typeof Any;
            const messageKey = errorCodeMessageMap[errorCode];

            if (messageKey) {
              message.error(clientI18n(messageKey));
            }
          }
        }
      },
    },
    fetch,
  );
}
